import { Capacitor } from "@capacitor/core";
import { Haptics, ImpactStyle, NotificationType } from "@capacitor/haptics";
import { toast } from "sonner";

const native = Capacitor.isNativePlatform();

const webVibrate = (ms) => { try { navigator.vibrate?.(ms); } catch {} };

export async function hapticImpact(style = "medium") {
  if (native) {
    const s = style === "light" ? ImpactStyle.Light : style === "heavy" ? ImpactStyle.Heavy : ImpactStyle.Medium;
    try { await Haptics.impact({ style: s }); } catch {}
  } else {
    webVibrate(style === "heavy" ? 30 : style === "medium" ? 15 : 8);
  }
}

export async function hapticSelection() {
  if (native) {
    try { await Haptics.selectionStart(); await Haptics.selectionChanged(); await Haptics.selectionEnd(); } catch {}
  } else {
    webVibrate(8);
  }
}

export async function hapticNotify(type = "success") {
  if (native) {
    const t = type === "error" ? NotificationType.Error : type === "warning" ? NotificationType.Warning : NotificationType.Success;
    try { await Haptics.notification({ type: t }); } catch {}
  } else {
    webVibrate(type === "error" ? [20, 40, 20] : 12);
  }
}

// Global hook: every success/error/warning toast in the app fires a matching
// native haptic — covers meal logging, water, saves, failures, etc.
let patched = false;
export function initHapticToasts() {
  if (patched) return;
  patched = true;
  const wrap = (fn, type) => (...args) => { hapticNotify(type); return fn(...args); };
  toast.success = wrap(toast.success.bind(toast), "success");
  toast.error = wrap(toast.error.bind(toast), "error");
  toast.warning = wrap(toast.warning.bind(toast), "warning");
}
